import Toastify from 'toastify-js';
import 'toastify-js/src/toastify.css';
import axios from 'axios';
import { find } from '../utils/dom';

const formPortalPrivacidade = () => {

    const form = find('[js-form="portal-privacidade"]');
    if (!form) return;

    // --- UTILS ---
    const showToastify = (message, type = "success") => {
        const bg = type === "error" ? "#FF3456" : "#ccab78";
        const color = type === "error" ? "white" : "black";

        Toastify({
            text: message,
            duration: 4000,
            gravity: "top",
            position: "center",
            close: true,
            style: {
                background: bg,
                color,
                borderRadius: "999px",
                padding: "12px 24px",
                fontFamily: "inherit",
                boxShadow: "0px 4px 10px rgba(0,0,0,0.1)"
            }
        }).showToast();
    };

    const getCookie = (name) => {
        return document.cookie
            ?.split(";")
            .map(c => c.trim())
            .find(c => c.startsWith(name + "="))
            ?.split("=")[1] || null;
    };

    // --- MASKS ---
    const $Mask = {
        phone: (value) => value
            .replace(/\D/g, '')
            .replace(/(\d{2})(\d)/, '($1) $2')
            .replace(/(\d{4,5})(\d{4})/, '$1-$2')
            .replace(/(-\d{4})\d+?$/, '$1'),

        cpf: (value) => value
            .replace(/\D/g, '')
            .replace(/(\d{3})(\d)/, '$1.$2')
            .replace(/(\d{3})(\d)/, '$1.$2')
            .replace(/(\d{3})(\d{1,2})/, '$1-$2')
            .replace(/(-\d{2})\d+?$/, '$1'),
    };

    form.querySelector('[name="telefone"]')?.addEventListener('input', (e) => {
        e.target.value = $Mask.phone(e.target.value);
    });

    form.querySelector('[name="cpf"]')?.addEventListener('input', (e) => {
        e.target.value = $Mask.cpf(e.target.value);
    });

    // --- VALIDATORS ---
    const validators = {
        email: (value) => /\S+@\S+\.\S+/.test(value),
        phone: (value) => value.replace(/\D/g, '').length >= 10,
        cpf: (value) => value.replace(/\D/g, '').length === 11,
        required: (value) => value.trim().length > 0,
    };

    // --- SUBMIT ---
    form.addEventListener("submit", async (e) => {
        e.preventDefault();

        const nome = form.querySelector("[name='nome']").value;
        const email = form.querySelector("[name='email']").value;
        const telefone = form.querySelector("[name='telefone']").value;
        const cpf = form.querySelector("[name='cpf']").value;

        // ---- VALIDATION ----
        if (!validators.required(nome)) return showToastify("Preencha seu nome.", "error");
        if (!validators.email(email)) return showToastify("E-mail inválido.", "error");
        if (!validators.phone(telefone)) return showToastify("Telefone inválido.", "error");
        if (!validators.cpf(cpf)) return showToastify("CPF inválido.", "error");

        const btnSubmit = form.querySelector("button[type=submit]");
        if (btnSubmit) {
            btnSubmit.disabled = true;
            btnSubmit.innerText = "Enviando...";
        }

        const payload = {
            nome,
            email,
            telefone,
            cpf,
            informacao_dados: form.querySelector("[name='informacao_dados']")?.checked ?? false,
            dados_que_empresa_possui: form.querySelector("[name='dados_que_empresa_possui']")?.checked ?? false,
            compartilhamento_dados: form.querySelector("[name='compartilhamento_dados']")?.checked ?? false,
            exclusao_dados: form.querySelector("[name='exclusao_dados']")?.checked ?? false,
            atualizacao_dados: form.querySelector("[name='atualizacao_dados']")?.checked ?? false,
            confirmacao_identidade: form.querySelector("[name='confirmacao_identidade']")?.checked ?? false,
        };

        const csrfToken = getCookie('csrftoken');
        const url = '/formulario-portal-privacidade/'
        try {
            const response = await axios.post(
                // window.location.pathname,
                url,
                payload,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'X-CSRFToken': csrfToken
                    }
                }
            );

            showToastify(
                response.data?.message || "Solicitação enviada com sucesso!"
            );

            form.reset();

        } catch (error) {
            console.error(error);
            showToastify("Erro ao enviar. Tente novamente.", "error");

        } finally {
            if (btnSubmit) {
                btnSubmit.disabled = false;
                btnSubmit.innerText = "Enviar";
            }
        }
    });

};

export default formPortalPrivacidade;
